import styles from "./GroupPage.module.css";
import classNames from "classnames";
import { useState } from "react";
import { useHistory } from "react-router-dom";

import Header from "DreamStream/Shared/Header";
import TabBar from "DreamStream/Shared/TabBar";
import { OptionsDropdown } from "DreamStream/Shared/OptionsDropdown/OptionsDropdown";
import MembersTab from "../MembersTab";
import AdminTab from "../AdminTab";
import ManageTab from "../ManageTab";
import DetailsTab from "../DetailsTab";

import DeleteHistoryModal from "../DeleteHistoryModal";
import SyncNowModal from "../SyncNowModal";
import ConfirmationModal from "DreamStream/Shared/ConfirmationModal";

/**
 *
 * shows details about a specific group
 */

export function GroupPage({}) {
  const history = useHistory();
  const [tab, setTab] = useState("Members");
  const [deleteHistoryModalOpen, setDeleteHistoryModalOpen] = useState(false);
  const [syncNowModalOpen, setSyncNowModalOpen] = useState(false);
  const [refreshNamesModalOpen, setRefreshNamesModalOpen] = useState(false);
  const [deleteGroupModalOpen, setDeleteGroupModalOpen] = useState(false);

  function getTabContent(tab) {
    switch (tab) {
      case "Members":
        return <MembersTab />;
      case "Admins":
        return <AdminTab />;
      case "Manage":
        return (
          <ManageTab
            status="Whitelist"
            lastSyncDate="11/18/2022 12:01 AM"
            lastSyncStatus="Complete"
            missingPluginsCount="101"
          />
        );
      case "Details":
        return (
          <DetailsTab
            detailedWorldwideGroupData={{
              id: "id",
              isDreamstreamDefault: "isDreamstreamDefault",
              isCommunity: "isCommunity",
              name: "name",
              privacy: "privacy",
              archived: "archived",
              postRequiresAdminApproval: "postRequiresAdminApproval",
              purpose: "purpose",
              postPermissions: "postPermissions",
              joinSettings: "joinSettings",
              isLosGroup: "isLosGroup",
              isWhitelisted: "isWhitelisted",
              groupType: "groupType",
              ownerIbo: "ownerIbo",
              groupPlugins: "groupPlugins",
              metagroupPluginsToThis: "metagroupPluginsToThis",
              metagroupPluginsFromThis: "metagroupPluginsFromThis",
            }}
            dreamStreamData={{
              id: "id",
              name: "name",
              privacy: "privacy",
            }}
          />
        );
    }
  }

  function deleteHistory(continueBool) {
    // TODO: put api call here
    setDeleteHistoryModalOpen(false);
    alert("deleteHistory called with: " + continueBool);
  }
  function handleOptionsDropdown(option) {
    switch (option) {
      case "Refresh Names":
        setRefreshNamesModalOpen(true);
        break;
      case "Delete History":
        setDeleteHistoryModalOpen(true);
        break;
      case "Delete Group":
        setDeleteGroupModalOpen(true);
        break;
      case "Sync Group":
        setSyncNowModalOpen(true);
        break;
    }
  }

  function sync(bool) {
    alert("sync called with: " + bool);
    setSyncNowModalOpen(false);
  }
  function refreshNames() {
    alert("refreshNames called");
    setRefreshNamesModalOpen(false);
  }
  function deleteGroup() {
    alert("deleteGroup called");
    setDeleteGroupModalOpen(false);
  }

  return (
    <div className={styles.container}>
      <Header
        title="[Group Name]"
        onClick={() => history.push("/dreamstream/groups")}
        children={
          <div className={styles.options}>
            <OptionsDropdown
              options={[
                "Refresh Names",
                "Delete History",
                "Delete Group",
                "Sync Group",
              ]}
              placeholder={"OPTIONS"}
              openedPlaceholder={"SELECT"}
              onChange={(option) => handleOptionsDropdown(option)}
            ></OptionsDropdown>
          </div>
        }
        back={true}
        backTitle="Back to Groups"
      />

      <div className={styles.tabBarContainer}>
        <TabBar
          titleList={["Members", "Admins", "Manage", "Details"]}
          activeTitle={tab}
          onChange={setTab}
        />
      </div>

      {getTabContent(tab)}

      <DeleteHistoryModal
        isOpen={deleteHistoryModalOpen}
        onClose={() => setDeleteHistoryModalOpen(false)}
        onClick={deleteHistory}
        continueBool={false}
      />

      <SyncNowModal
        isOpen={syncNowModalOpen}
        onClose={() => setSyncNowModalOpen(false)}
        onClick={sync}
        withoutRefresh={false}
      />

      <ConfirmationModal
        isOpen={refreshNamesModalOpen}
        onClose={() => setRefreshNamesModalOpen(false)}
        onClick={refreshNames}
        header="REFRESH NAMES"
        description="Confirm that you want to refresh cached group names from the latest Dreamstream data."
        btnName="REFRESH"
      />

      <ConfirmationModal
        isOpen={deleteGroupModalOpen}
        onClose={() => setDeleteGroupModalOpen(false)}
        onClick={deleteGroup}
        header="DELETE GROUP"
        description="Are you sure that you would like to delete [Name of Group]. This action cannot be undone."
        btnName="Delete"
      />
    </div>
  );
}
